import axios from 'axios';
import moment from 'moment-timezone';
import liff from '@line/liff';

import api from './api';
import clinic from './clinic';
import crud from './crud';
import libs from './libs/index';

moment.tz.setDefault('Asia/Taipei');
export default {
  axios,
  moment,
  liff,
  api,
  clinic,
  crud,
  ...libs,
};
